<template>
  <div class="page task-page">
    <h2 class="page-title">检测与修缮申请及进度看板</h2>
    <el-row :gutter="18" style="margin-bottom:18px">
      <el-col :span="12">
        <div class="panel-card">
          <div class="panel-title">待检测排行</div>
          <el-table :data="testRank" :row-class-name="rankClass" size="small">
            <el-table-column type="index" width="50" label="#" />
            <el-table-column prop="wellName" label="泉井" />
            <el-table-column prop="votes" label="助力值" width="90" />
            <el-table-column label="标签" width="110"><template slot-scope="scope"><el-tag v-if="scope.$index < 3" type="warning">急需检测</el-tag></template></el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="panel-card">
          <div class="panel-title">待修缮排行</div>
          <el-table :data="repairRank" :row-class-name="rankClass" size="small">
            <el-table-column type="index" width="50" label="#" />
            <el-table-column prop="wellName" label="泉井" />
            <el-table-column prop="votes" label="助力值" width="90" />
            <el-table-column label="标签" width="110"><template slot-scope="scope"><el-tag v-if="scope.$index < 3" type="danger">急需修缮</el-tag></template></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-tabs v-model="active" class="table-card">
      <el-tab-pane label="检测申请" name="test">
        <div class="filter-inline">
          <el-form :inline="true" :model="testQuery" size="small">
            <el-form-item label="泉井名称"><el-input v-model="testQuery.wellName" placeholder="输入泉井名称" clearable style="width:150px" /></el-form-item>
            <el-form-item label="申请人"><el-input v-model="testQuery.keyword" placeholder="姓名/电话" clearable style="width:130px" /></el-form-item>
            <el-form-item label="检测类型">
              <el-select v-model="testQuery.testType" clearable placeholder="全部" style="width:110px">
                <el-option label="常规检测" :value="1" /><el-option label="专项检测" :value="2" /><el-option label="异常复检" :value="3" />
              </el-select>
            </el-form-item>
            <el-form-item label="紧急程度">
              <el-select v-model="testQuery.urgency" clearable placeholder="全部" style="width:90px">
                <el-option label="紧急" :value="1" /><el-option label="一般" :value="2" /><el-option label="不急" :value="3" />
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="testQuery.status" clearable placeholder="全部" style="width:90px">
                <el-option label="待处理" :value="0" /><el-option label="处理中" :value="1" /><el-option label="已完成" :value="2" /><el-option label="已关闭" :value="3" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchTest">查询</el-button>
              <el-button @click="resetTest">重置</el-button>
              <el-button @click="exportTestList">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        
        <el-table :data="testList" v-loading="testLoading" border>
          <el-table-column prop="id" label="ID" width="70" />
          <el-table-column prop="wellName" label="泉井名称" min-width="140" show-overflow-tooltip />
          <el-table-column prop="applicantName" label="申请人" width="110" />
          <el-table-column prop="contact" label="联系方式" width="130" />
          <el-table-column label="检测类型" width="110"><template slot-scope="scope">{{ testTypeText(scope.row.testType) }}</template></el-table-column>
          <el-table-column label="紧急程度" width="100"><template slot-scope="scope"><el-tag :type="urgencyTagType(scope.row.urgency)" size="small">{{ urgencyText(scope.row.urgency) }}</el-tag></template></el-table-column>
          <el-table-column label="现场照片" width="80"><template slot-scope="scope"><el-image v-if="scope.row.images && scope.row.images.length" :src="resolveImageUrl(scope.row.images[0])" :preview-src-list="resolveImageList(scope.row.images)" style="width:40px;height:40px;border-radius:4px" fit="cover" /><span v-else class="empty-tip">无</span></template></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
          <el-table-column prop="votes" label="助力值" width="80" />
          <el-table-column label="状态" width="100"><template slot-scope="scope"><el-tag :type="testStatusTagType(scope.row.status)" size="small">{{ testStatusText(scope.row.status) }}</el-tag></template></el-table-column>
          <el-table-column label="提交时间" width="160"><template slot-scope="scope">{{ formatDateTime(scope.row.createdAt) }}</template></el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <div class="action-bar">
                <span class="action-text primary" :class="{ disabled: scope.row.status === 2 }" @click="scope.row.status !== 2 && openReport(scope.row)">上传报告</span>
                <span class="action-text delete" @click="handleDeleteTest(scope.row)">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next, total" :total="testTotal" :current-page.sync="testQuery.pageNum" :page-size="testQuery.pageSize" @current-change="loadTestList" style="margin-top:16px;text-align:right" />
      </el-tab-pane>
      <el-tab-pane label="修缮申请" name="repair">
        <div class="filter-inline">
          <el-form :inline="true" :model="repairQuery" size="small">
            <el-form-item label="泉井名称"><el-input v-model="repairQuery.wellName" placeholder="输入泉井名称" clearable style="width:150px" /></el-form-item>
            <el-form-item label="申请人"><el-input v-model="repairQuery.keyword" placeholder="姓名/电话" clearable style="width:130px" /></el-form-item>
            <el-form-item label="修缮类型"><el-input v-model="repairQuery.repairType" placeholder="修缮类型" clearable style="width:130px" /></el-form-item>
            <el-form-item label="紧急程度">
              <el-select v-model="repairQuery.urgency" clearable placeholder="全部" style="width:90px">
                <el-option label="紧急" :value="1" /><el-option label="一般" :value="2" /><el-option label="不急" :value="3" />
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="repairQuery.status" clearable placeholder="全部" style="width:90px">
                <el-option label="待修缮" :value="0" /><el-option label="修缮中" :value="1" /><el-option label="已完成" :value="2" /><el-option label="已关闭" :value="3" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchRepair">查询</el-button>
              <el-button @click="resetRepair">重置</el-button>
              <el-button @click="exportRepairList">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="repairList" v-loading="repairLoading" border>
          <el-table-column prop="id" label="ID" width="70" />
          <el-table-column prop="wellName" label="泉井名称" min-width="140" show-overflow-tooltip />
          <el-table-column prop="applicantName" label="申请人" width="110" />
          <el-table-column prop="contact" label="联系方式" width="130" />
          <el-table-column prop="repairType" label="修縮类型" width="120" />
          <el-table-column prop="description" label="问题描述" min-width="160" show-overflow-tooltip />
          <el-table-column label="紧急程度" width="100"><template slot-scope="scope"><el-tag :type="urgencyTagType(scope.row.urgency)" size="small">{{ urgencyText(scope.row.urgency) }}</el-tag></template></el-table-column>
          <el-table-column label="预算范围" width="140"><template slot-scope="scope">{{ scope.row.budgetMin }}-{{ scope.row.budgetMax }}元</template></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
          <el-table-column prop="votes" label="助力值" width="80" />
          <el-table-column label="状态" width="100"><template slot-scope="scope"><el-tag :type="repairStatusTagType(scope.row.status)" size="small">{{ repairStatusText(scope.row.status) }}</el-tag></template></el-table-column>
          <el-table-column label="提交时间" width="160"><template slot-scope="scope">{{ formatDateTime(scope.row.createdAt) }}</template></el-table-column>
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <span class="action-text delete" @click="handleDeleteRepair(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next, total" :total="repairTotal" :current-page.sync="repairQuery.pageNum" :page-size="repairQuery.pageSize" @current-change="loadRepairList" style="margin-top:16px;text-align:right" />
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="上传检测报告" :visible.sync="reportVisible" width="560px">
      <el-form :model="reportForm" label-width="110px">
        <el-form-item label="检测日期"><el-date-picker v-model="reportForm.testDate" value-format="yyyy-MM-dd" type="date" style="width:100%" /></el-form-item>
        <el-form-item label="检测机构"><el-input v-model="reportForm.testOrg" /></el-form-item>
        <el-form-item label="报告文件"><el-input v-model="reportForm.reportFile" placeholder="报告图片/文档URL" /></el-form-item>
        <el-form-item label="检测结论">
          <el-radio-group v-model="reportForm.testResult">
            <el-radio :label="1">可用</el-radio>
            <el-radio :label="2">不可用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="reportVisible = false">取消</el-button>
        <el-button type="primary" @click="submitReport">提交报告</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchRank, fetchTestList, fetchRepairList, submitTestReport, deleteTestApply, deleteRepairApply } from '@/api'
import { resolveImageUrl, resolveImageList } from '@/utils/media'

export default {
  data() {
    return {
      active: 'test',
      testRank: [], repairRank: [],
      testLoading: false, repairLoading: false,
      testList: [], testTotal: 0,
      repairList: [], repairTotal: 0,
      testQuery: { pageNum: 1, pageSize: 10, wellName: '', keyword: '', testType: undefined, urgency: undefined, status: undefined },
      repairQuery: { pageNum: 1, pageSize: 10, wellName: '', keyword: '', repairType: '', urgency: undefined, status: undefined },
      reportVisible: false, reportForm: {}
    }
  },
  created() { this.loadRank(); this.loadTestList(); this.loadRepairList() },
  methods: {
    resolveImageUrl, resolveImageList,
    async loadRank() {
      const [tr, rr] = await Promise.all([fetchRank({ targetType: 1, limit: 10 }), fetchRank({ targetType: 2, limit: 10 })])
      this.testRank = tr || []; this.repairRank = rr || []
    },
    async loadTestList() {
      this.testLoading = true
      try {
        const params = { ...this.testQuery }
        Object.keys(params).forEach(k => { if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k] })
        const res = await fetchTestList(params)
        this.testList = res.records || []; this.testTotal = res.total || 0
      } finally { this.testLoading = false }
    },
    async loadRepairList() {
      this.repairLoading = true
      try {
        const params = { ...this.repairQuery }
        Object.keys(params).forEach(k => { if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k] })
        const res = await fetchRepairList(params)
        this.repairList = res.records || []; this.repairTotal = res.total || 0
      } finally { this.repairLoading = false }
    },
    searchTest() { this.testQuery.pageNum = 1; this.loadTestList() },
    resetTest() { this.testQuery = { pageNum: 1, pageSize: 10, wellName: '', keyword: '', testType: undefined, urgency: undefined, status: undefined }; this.loadTestList() },
    searchRepair() { this.repairQuery.pageNum = 1; this.loadRepairList() },
    resetRepair() { this.repairQuery = { pageNum: 1, pageSize: 10, wellName: '', keyword: '', repairType: '', urgency: undefined, status: undefined }; this.loadRepairList() },
    rankClass({ rowIndex }) { return rowIndex < 3 ? 'rank-top' : '' },
    openReport(row) { this.reportForm = { wellId: row.wellId, appId: row.id, testDate: '', testOrg: '', reportFile: '', testResult: 1 }; this.reportVisible = true },
    async submitReport() {
      await submitTestReport(this.reportForm)
      this.$message.success('检测报告已上传')
      this.reportVisible = false; this.loadTestList()
    },
    async handleDeleteTest(row) {
      try {
        await this.$confirm('确认删除泉井「' + row.wellName + '」的检测申请吗？', '删除确认', { type: 'warning' })
        await deleteTestApply(row.id); this.$message.success('已删除'); this.loadTestList()
      } catch (e) {}
    },
    async handleDeleteRepair(row) {
      try {
        await this.$confirm('确认删除泉井「' + row.wellName + '」的修縮申请吗？', '删除确认', { type: 'warning' })
        await deleteRepairApply(row.id); this.$message.success('已删除'); this.loadRepairList()
      } catch (e) {}
    },
    exportTestList() {
      const h = ['ID','泉井名称','申请人','联系方式','检测类型','紧急程度','备注','助力值','状态','提交时间']
      const r = this.testList.map(row => [row.id,row.wellName,row.applicantName,row.contact,this.testTypeText(row.testType),this.urgencyText(row.urgency),row.remark,row.votes,this.testStatusText(row.status),this.formatDateTime(row.createdAt)])
      this.downloadCsv(h, r, '检测申请')
    },
    exportRepairList() {
      const h = ['ID','泉井名称','申请人','联系方式','修縮类型','问题描述','紧急程度','预算下限','预算上限','备注','助力值','状态','提交时间']
      const r = this.repairList.map(row => [row.id,row.wellName,row.applicantName,row.contact,row.repairType,row.description,this.urgencyText(row.urgency),row.budgetMin,row.budgetMax,row.remark,row.votes,this.repairStatusText(row.status),this.formatDateTime(row.createdAt)])
      this.downloadCsv(h, r, '修縮申请')
    },
    downloadCsv(headers, rows, name) {
      const csv = [headers,...rows].map(items => items.map(v => '"' + String(v==null?'':v).replace(/"/g,'""')+'"').join(',')).join('\n')
      const blob = new Blob(['\ufeff'+csv],{type:'text/csv;charset=utf-8;'})
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = name+'_'+new Date().toISOString().slice(0,10)+'.csv'
      link.click(); URL.revokeObjectURL(link.href)
    },
    formatDateTime(v) { return v ? String(v).replace('T', ' ') : '-' },
    testTypeText(v) { return v===1?'常规检测':v===2?'专项检测':v===3?'异常复检':'未知' },
    urgencyText(v) { return v===1?'紧急':v===2?'一般':'不急' },
    urgencyTagType(v) { return v===1?'danger':v===2?'warning':'info' },
    testStatusText(v) { return v===0?'待处理':v===1?'处理中':v===2?'已完成':'已关闭' },
    testStatusTagType(v) { return v===2?'success':v===0?'warning':'info' },
    repairStatusText(v) { return v===0?'待修縮':v===1?'修縮中':v===2?'已完成':'已关闭' },
    repairStatusTagType(v) { return v===0?'danger':v===1?'warning':v===2?'success':'info' }
  }
}
</script>

<style scoped>
.panel-card { background: #fff; border-radius: 12px; padding: 18px; box-shadow: 0 2px 12px rgba(0,0,0,.06); }
.panel-title { font-weight: 800; color: #123c2f; margin-bottom: 12px; }
.filter-inline { margin-bottom: 12px; }
.action-bar { display: flex; align-items: center; gap: 10px; }
.action-text { cursor: pointer; font-size: 13px; }
.action-text:hover { text-decoration: underline; }
.action-text.primary { color: #409eff; }
.action-text.delete { color: #f56c6c; }
.action-text.disabled { color: #c0c4cc; cursor: not-allowed; }
.action-text.disabled:hover { text-decoration: none; }
.empty-tip { color: #999; }
::v-deep .rank-top td { background: #fffbe6 !important; }
</style>
